module.exports = __webpack_public_path__ + "80423ce6a498f133ea9c97298aa64632.svg";